import { Ornt } from '../types';

export default (
	text: string,
	targetOrnt: Ornt,
	maxSize: {
		[Ornt.X]?: number;
		[Ornt.Y]?: number;
	},
	fontSize = 16
) => {
	const div = document.createElement('div');
	div.innerText = text;
	div.style.wordWrap = 'break-word';
	div.style.display = 'inline-block';
	div.style.fontSize = fontSize + 'px';
	div.style.lineHeight = fontSize + 'px';

	maxSize.width && (div.style.maxWidth = maxSize.width + 'px');
	maxSize.height && (div.style.maxHeight = maxSize.height + 'px');

	document.body.appendChild(div);
	const result = +getComputedStyle(div)[targetOrnt].slice(0, -2);
	document.body.removeChild(div);
	return result;
};
